export const numberFormatFrMixin = {
    methods: {
        numberFormatFr(number) {
            return new Intl.NumberFormat('fr').format(number)
      }
    }
  }